<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل منطقة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/regionsview">المناطق</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل منطقة</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="loader" class="text-center">
          <mainLoader />
        </div>

        <div v-if="!loader" class="row justify-content-center align-content-center mb-4 mt-5">
          <div class="col-12 col-md-8">
            <h5 class="text-brown mx-2">
              <i class="bi bi-pencil-square mx-2 text-brown"></i> عرض البيانات
            </h5>
            <div class="card">
              <div v-if="successfuly" class="pt-3 text-center">
                <successAlert :message= "message" />
              </div>
              <div class="card-body">
                <errorAlert v-if="regionError" :alertMessage= "message" />
                <div class="row py-2">
                  <div class="col-12 col-sm-6">
                    <label for="">الاسم - عربي</label>
                    <div>{{ regionName }}</div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <label for="">الاسم - إنجليزي</label>
                    <div>{{ nameEn }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label for="">الحاله</label>
                    <div>{{ (status)? 'نشط' : 'غير نشط' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
export default {
  name:'RegionsRead',
  data(){
    return {
      regions_id: this.$route.params.id,
      loader: false,
      regionError: false,
      message: '',
      regionName: "",
      nameEn: "",
      isLoading: false,
      status: true,
      successfuly: false,
    }
  },
  methods:{
    region_get_Data() {
      this.regionError = false;
      this.loader = true;
      this.$http.get(`/api/admin/regions/retrieve/${this.regions_id}`).then(res => {
        // console.log(res);
        this.loader = false;
        this.regionName = res.data.region.name;
        this.nameEn = res.data.region.nameEn;
        this.status = res.data.region.isActive;
      }).catch(err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.regionError = true;
        this.loader = false;
        window.scroll(0,0);
      })
    },
  },
  created() {
    this.region_get_Data();
  }
}
</script>